// @flow

import styled, { css } from "styled-components";
import { Link } from "react-router-dom";
import ButtonLink from "../../_atom/Buttons/buttonLink";
import Icon from "../../_static/Icons";

import buildColor from "../../_static/ColorPalette";
import { buildText } from "../../_atom/Text";
import ExpandableRow from "../ExpandableRow";
import { fontMedium } from "../../_static/Typography";

const listItemStyling = `
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  text-decoration: none;
  outline: none;
  color: ${buildColor("grey", "900")};
  background-color: ${buildColor("white", "100")};

`;

export const ProductTitle = styled(
  buildText({
    tag: "span",
    fontSize: 14
  })
)`
  font-family: ${fontMedium};
`;

export const ProductDescription = buildText({
  fontSize: 14,
  color: buildColor("grey", "800")
});

export const TracksNamesList = styled(
  buildText({
    fontSize: 12,
    color: buildColor("grey", "800")
  })
)`
  display: block;
`;

export const HandicappingStoreItem = styled.li`
  height: 56px;
  background-color: ${buildColor("white", "100")};
  position: relative;
  ${(props) =>
    props.borderTop
      ? css`
          border-top: 1px solid ${buildColor("blue", "100")};
        `
      : css`
          border-bottom: 1px solid
            ${props.borderBlueColor
              ? buildColor("blue", "100")
              : buildColor("blue", "100")};
        `};
`;

export const HandicappingItemWrapper = styled.div`
  ${listItemStyling};
  padding: 0 8px;
  min-height: 40px;

  & > dl {
    flex: 1 1 auto;
    padding-left: 8px;
  }

  &:active,
  &:hover {
    background-color: ${buildColor("blue", "000")};
  }
`;

export const HandicappingItemLink = styled(Link)`
  ${listItemStyling};
  padding-left: 8px;
  min-height: 40px;

  &:active,
  &:hover {
    background-color: ${buildColor("blue", "000")};
  }
`;

export const ExpandableHeaderWrapper = styled.div`
  ${listItemStyling};
  height: 72px;

  &:active {
    background-color: ${buildColor("blue", "000")};
  }

  & > dl {
    padding-left: 8px;
    width: 100%;
    white-space: nowrap;
  }
`;

export const ExpandableProduct = styled(ExpandableRow)`
  border-bottom: 1px solid ${buildColor("blue", "100")};
`;

export const SeeAllButton = styled(HandicappingItemLink)`
  text-transform: capitalize;
  color: ${buildColor("blue_accent", "500")};
  text-align: left;
  font-size: 14px;
  border-bottom: 1px solid ${buildColor("grey", "300")};
  border-top: 1px solid ${buildColor("blue", "100")};
  height: 56px;
  position: relative;
  font-family: ${fontMedium};
`;

export const ProductList = styled.dl`
  list-style-type: none;

  & > li:last-child {
    border-bottom: none;
  }

  & > dd {
    text-align: left;
  }
`;

export const IntTrackContainer = styled.div`
  background: ${buildColor("white", "100")};
  padding: 16px 8px;
  text-align: center;
`;

export const IntTracksButton = styled(ButtonLink)`
  margin-top: 16px;
  font-size: 14px;
  font-family: ${fontMedium};
`;

export const ArrowIcon = styled(Icon)`
  position: absolute;
  right: 8px;
`;

export const ProcessingContainer = styled.div`
  position: relative;
  min-height: 300px;
`;

export const SeeCardButton = styled(Link)`
  height: ${(props) => (props.device === "mobile" ? "24px" : "32px")};
  padding: 0 8px;
  font-size: 11px;
  background-color: ${buildColor("blue_accent", "500")};
  color: ${buildColor("white", "100")};
  border: none;
  font-weight: bold;
  text-transform: uppercase;
  border-radius: 2px;
  text-decoration: none;
  flex-shrink: 0;

  & > span {
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
    line-height: 1;
  }

  &:hover {
    background-color: ${buildColor("blue_accent", "400")};
  }
`;
